<div class="searchable-select" [class.is-open]="isOpen">
  <div class="input-wrap">
    <input
      class="searchable-input"
      nbInput
      fullWidth
      type="text"
      [placeholder]="placeholder"
      [value]="inputText"
      [readonly]="!editable"
      [disabled]="disabled"
      (mousedown)="onInputMouseDown()"
      (click)="toggleDropdown($event)"
      (focus)="onInputFocus($event)"
      (input)="onMainInput($event)"
      (keydown.enter)="selectExactMatch()"
      (blur)="selectExactMatch()" />

    <nb-icon class="toggle-icon" [icon]="isOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
  </div>

  <div class="options-panel" *ngIf="isOpen && !disabled">
    <div class="search-box">
      <input
        #searchInput
        class="dropdown-search-input"
        nbInput
        fullWidth
        type="text"
        [placeholder]="placeholder"
        [value]="searchText"
        (input)="onSearchInput($event)"
        (click)="$event.stopPropagation()" />
    </div>

    <button
      type="button"
      class="option-item"
      [class.selected]="isOptionSelected(option)"
      [attr.aria-selected]="isOptionSelected(option)"
      *ngFor="let option of filteredOptions"
      (mousedown)="selectOption(option, $event)">
      <span>{{ getOptionLabel(option) }}</span>
      <nb-icon
        *ngIf="isOptionSelected(option)"
        class="selected-icon"
        icon="checkmark-outline"
        aria-hidden="true">
      </nb-icon>
    </button>

    <div class="no-results" *ngIf="!filteredOptions.length">
      {{ noResultsText }}
    </div>
  </div>
</div>
